import React, { Component, PropTypes } from 'react';
import { Deck } from 'spectacle-ppa';
import { i18nProvider } from 'helpers/i18n'

import start from './sections/01_start/startSection';
import song from './sections/03_song/songSection';
import missionReport from './sections/11_missionReport/missionReportSection';
import esStory from './sections/12_esStory/esStorySection';
import mme from './sections/13_mme/mmeSection';
import gameShow from './sections/20_gameShow/gameShowSection';
import classActivity from './sections/30_classActivity/classActivitySection';
import missionAssignment from
  './sections/70_missionAssignment/missionAssignmentSection';
import finish from './sections/90_finish/finishSection';
import md from './md';

const level = Number(__filename.replace(/^.*level/, '').replace('.jsx', ''));
const _title = i18nProvider(lang => md[lang].getSectionMetadata(`Level ${level}`, 'Title'));

export default class extends Component {

  static contextTypes = {
    regionData: PropTypes.object.isRequired,
    i18n: PropTypes.func.isRequired
  };

  static metadata = {
    title: _title
  };

  render() {
    const { regionData, i18n } = this.context;
    const title = i18n(_title);
    return (
      <Deck transition={['slide']}
            transitionDuration={800}
            progress="bar">

        {/* Start */}
        {start({ level, title, regionData, i18n })}

        {/* Theme Song */}
        {song({ level, regionData, i18n })}

        {/* Mission Report */}
        {missionReport({ level, regionData, i18n })}

        {/* Es Story 2a */}
        {esStory({ level, subStory: 'a', regionData, i18n })}

        {/* Game Show */}
        {gameShow({ level, regionData, i18n })}

        {/* Messages from Mother Earth */}
        {mme({ level, regionData, i18n })}

        {/* Class Activity: Group Drawing */}
        {classActivity({ level, regionData, i18n })}

        {/* Mission Assignment */}
        {missionAssignment({ level, title, regionData, i18n })}

        {/* Finish */}
        {finish({ level, regionData, i18n })}

      </Deck>
    );
  }

}



// WEBPACK FOOTER //
// ./programs/h2whoa/level2.jsx